<template>
  <div class="relative md:w-[525px] w-full md:h-[245px]" v-if="property">
    <img
      :src="property.photos[0]"
      class="w-full h-full rounded-lg md:rounded-none md:rounded-tl-lg"
      alt=""
    />
    <!-- <TagsView :property="property" /> -->
    <div class="flex justify-between">
      <div class="absolute bottom-0 left-0 ml-2 md:ml-0">
        <button
          class="flex items-center justify-center p-1 text-sm text-white bg-gray-700 bg-opacity-70"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-4 h-4"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6.827 6.175A2.31 2.31 0 0 1 5.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 0 0-1.134-.175 2.31 2.31 0 0 1-1.64-1.055l-.822-1.316a2.192 2.192 0 0 0-1.736-1.039 48.774 48.774 0 0 0-5.232 0 2.192 2.192 0 0 0-1.736 1.039l-.821 1.316Z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M16.5 12.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM18.75 10.5h.008v.008h-.008V10.5Z"
            />
          </svg>
          <span class="ml-1">{{ property.photos.length }}</span>
        </button>
      </div>
      <!-- <div class="absolute bottom-0 right-0 mb-4 mr-4">
        <button
          class="flex items-center justify-center p-1 text-black bg-white border rounded-md"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-5 h-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
            />
          </svg>
        </button>
      </div> -->
    </div>
  </div>
</template>
<script>
// import TagsView from "./TagsView.vue";
export default {
  components: {
    // TagsView,
  },
  props: {
    property: {
      type: Object,
    },
  },
  data() {
    return {};
  },
};
</script>
